const calcRowPositions = (stateWidgets, spacing, widgetSizes) => {
  let height = 0;

  return stateWidgets.reduce((acc, row, indexRow) => {
    const heightRow = Math.max(...row.map(({ id }) => widgetSizes[id]?.height));

    if (!heightRow) {
      const { to = 0 } = acc[indexRow - 1] || {};
      return [
        ...acc,
        {
          from: to,
          to: to,
        },
      ];
    }

    const from = height + indexRow * spacing;

    height += heightRow;

    return [
      ...acc,
      {
        from,
        to: from + heightRow,
      },
    ];
  }, []);
};

const calcWidgetPositions = (
  stateWidgets,
  rowPositions,
  boardWidth,
  spacing
) => {
  return stateWidgets.reduce((acc, row, indexRow) => {
    const { from } = rowPositions[indexRow];
    const firstRow = indexRow === 0;
    const lastRow = indexRow === stateWidgets.length - 1;
    return [
      ...acc,
      ...row.map(({ id, collapsed }, indexCell) => {
        const cellCount = row.length;
        const width = boardWidth / cellCount;
        const widthForSpace = (spacing * (cellCount - 1)) / cellCount;
        return {
          id,
          collapsed,
          indexRow,
          firstRow,
          lastRow,
          position: {
            top: from,
            left: (width - widthForSpace) * indexCell + indexCell * spacing,
            width: width - widthForSpace,
          },
        };
      }),
    ];
  }, []);
};

export const calcStatePosition = ({
  stateWidgets,
  spacing = 0,
  boardWidth = 0,
  widgetSizes = {},
}) => {
  let rowPositions = null;
  let widgetPositions = null;
  if (!stateWidgets) {
    return { rowPositions, widgetPositions };
  }
  rowPositions = calcRowPositions(stateWidgets, spacing, widgetSizes);
  widgetPositions = calcWidgetPositions(
    stateWidgets,
    rowPositions,
    boardWidth,
    spacing
  );
  return { rowPositions, widgetPositions };
};
